export default __webpack_public_path__ + "static/media/fa.bundle.59214132.svg";